// extracted by mini-css-extract-plugin
export var container = "Footer-module--container--1RDYA";
export var contentContainer = "Footer-module--content-container--3us2L";
export var emailRow = "Footer-module--email-row--malZy";
export var bottomContainer = "Footer-module--bottom-container--3BURv";
export var linksRow = "Footer-module--links-row--1lAAN";